import { TermsConsent } from "@/data/payload/app-account-setting/add-app-account-request-payload";
import { AppAccountSettingRepository } from "@/domain/repository/app-account-setting-repository";

export class SaveTermsConsentUsecase {
  constructor(private readonly repo: AppAccountSettingRepository) {}

  execute(termsConsent: TermsConsent[]) {
    return this.repo.saveTermsConsent(termsConsent);
  }
}
